import { createTheme } from '@mui/material';

// A custom theme for this app
const theme = createTheme({
  typography: {
    h1: {
      fontFamily: "Inter",
      lineHeight: 1,
    },
    h2: {
      fontFamily: "Inter",
      lineHeight: 1,
    },
    h3: {
      fontFamily: "Inter",
      lineHeight: 1,
      fontSize: '2.5rem',
    },
    h4: {
      lineHeight: 1,
    },
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`
  },
  components: {
    MuiCardContent :{
      styleOverrides: {
        root:{
          borderRadius: 15,
          overflow: 'auto',
          "&:last-child": {
            paddingBottom: '16px'
          },
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // textTransform: 'none',
          fontSize: '1rem',
          boxShadow: 'none',
          borderRadius: '20px',
          "&:hover": {
            boxShadow: 'none',
          },
        },
        outlinedSizeMedium: {
          height: 36,
        },
        contained: {
          color: 'white',
        },
        outlined: {
          backgroundColor: 'white'
        }
      }
    },
    MuiFab: {
      styleOverrides: {
        root: {
          // textTransform: 'none',
          fontSize: '1rem',
          fontWeight: 600,
        },
      }
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: "#000000",
    },
    action: {
      main: "#38A6FA",
      light: "#4fb3ff",
      dark: "#4fb3ff",
    },
    secondary: {
      main: "#414141",
    },
    background: {
      default: `#fff`,
    },
    info: {
      main: `#eef0f3`
    }
  },
});

export default theme;
